// Exchange + routing/queue names usati su RabbitMQ.

export const ECONOMIC_EXCHANGE = 'economic.events';

// session.ended → routed by sessionId so retro-routing per session è possibile
export const sessionEndedRoutingKey = (sessionId: string) => `${sessionId}.session.ended`;
export const SESSION_ENDED_PATTERN = '*.session.ended';

// cdr.ready
export const cdrReadyRoutingKey = (cdrId: string) => `${cdrId}.cdr.ready`;
export const CDR_READY_PATTERN = '*.cdr.ready';

// payment.charged
export const paymentChargedRoutingKey = (cdrId: string) => `${cdrId}.payment.charged`;
export const PAYMENT_CHARGED_PATTERN = '*.payment.charged';

// cdr.pushed-to-oicp (status finale dal gateway)
export const cdrPushedRoutingKey = (cdrId: string) => `${cdrId}.cdr.pushed-to-oicp`;
export const CDR_PUSHED_PATTERN = '*.cdr.pushed-to-oicp';

// oicp.cdr-push.requested (engine → oicp-gateway via RMQ, NON HTTP)
export const oicpCdrPushRequestedRoutingKey = (cdrId: string) => `${cdrId}.oicp.cdr-push.requested`;
export const OICP_CDR_PUSH_REQUESTED_PATTERN = '*.oicp.cdr-push.requested';

// Queue names lato consumer. Convention: q.<service>.<event>
export const Q_ECONOMIC_SESSION_ENDED = 'q.economic-engine.session.ended';
export const Q_ECONOMIC_SESSION_ENDED_DLQ = 'q.economic-engine.session.ended.dlq';

export const Q_PAYMENTS_CDR_READY = 'q.payments.cdr.ready';
export const Q_PAYMENTS_CDR_READY_DLQ = 'q.payments.cdr.ready.dlq';

export const Q_OICP_PUSH_CDR_READY = 'q.oicp-push.cdr.ready';
export const Q_OICP_PUSH_CDR_READY_DLQ = 'q.oicp-push.cdr.ready.dlq';

// Consumer lato oicp-gateway container per le richieste di push CDR
export const Q_OICP_GATEWAY_CDR_PUSH = 'q.oicp-gateway.cdr-push.requested';
export const Q_OICP_GATEWAY_CDR_PUSH_DLQ = 'q.oicp-gateway.cdr-push.requested.dlq';

// Nota: meter-value.observed e mid-session.charged RIMOSSI (trust mid-session
// billing eliminato con la pre-auth — flusso engine e legacy backend entrambi
// rimossi).

// Consumer dedicato invoicing (corrispettivo + fattura) lato economic-engine
export const Q_INVOICING_PAYMENT_CHARGED = 'q.invoicing.payment.charged';
export const Q_INVOICING_PAYMENT_CHARGED_DLQ = 'q.invoicing.payment.charged.dlq';

// ---- queue lato backend (observability + notifiche utente) -----------
// Il backend si sottoscrive agli eventi emessi dall'engine per:
//  - verificare che il CDR esista (cdr.ready)
//  - emettere notifiche utente via EventEmitter2 (payment.charged)
//  - audit-only (cdr.pushed-to-oicp)
export const Q_BACKEND_CDR_READY = 'q.backend.cdr.ready';
export const Q_BACKEND_CDR_READY_DLQ = 'q.backend.cdr.ready.dlq';

export const Q_BACKEND_PAYMENT_CHARGED = 'q.backend.payment.charged';
export const Q_BACKEND_PAYMENT_CHARGED_DLQ = 'q.backend.payment.charged.dlq';

export const Q_BACKEND_CDR_PUSHED = 'q.backend.cdr.pushed-to-oicp';
export const Q_BACKEND_CDR_PUSHED_DLQ = 'q.backend.cdr.pushed-to-oicp.dlq';

// ---- oicp.evse-data.observed / oicp.evse-status.observed ---------------
// (oicp-gateway → backend) Trasporto RMQ degli EVSE roaming osservati dal pull
// Hubject. Subject = evseId quando estraibile, altrimenti messageId (bind
// comunque wildcard). Volumi alti: il consumer backend fa solo enqueue nella
// coda Redis interna (latest-wins), il lavoro pesante resta lì.
export const oicpEvseDataObservedRoutingKey = (subjectId: string) =>
  `${subjectId}.oicp.evse-data.observed`;
export const OICP_EVSE_DATA_OBSERVED_PATTERN = '*.oicp.evse-data.observed';
export const oicpEvseStatusObservedRoutingKey = (subjectId: string) =>
  `${subjectId}.oicp.evse-status.observed`;
export const OICP_EVSE_STATUS_OBSERVED_PATTERN = '*.oicp.evse-status.observed';

export const Q_BACKEND_OICP_EVSE_DATA_OBSERVED = 'q.backend.oicp.evse-data.observed';
export const Q_BACKEND_OICP_EVSE_DATA_OBSERVED_DLQ = 'q.backend.oicp.evse-data.observed.dlq';
export const Q_BACKEND_OICP_EVSE_STATUS_OBSERVED = 'q.backend.oicp.evse-status.observed';
export const Q_BACKEND_OICP_EVSE_STATUS_OBSERVED_DLQ = 'q.backend.oicp.evse-status.observed.dlq';

// ---- oicp.evse-status.push.requested (backend → oicp-gateway) ---------
// Comando push stato EVSE (noi CPO) verso Hubject, fire-and-forget: il
// messaggio resta in coda finché il gateway non consuma (sparisce il gate
// "operator_not_connected" del WS sincrono).
export const oicpEvseStatusPushRequestedRoutingKey = (evseId: string) =>
  `${evseId}.oicp.evse-status.push.requested`;
export const OICP_EVSE_STATUS_PUSH_REQUESTED_PATTERN = '*.oicp.evse-status.push.requested';

export const Q_OICP_GATEWAY_EVSE_STATUS_PUSH = 'q.oicp-gateway.evse-status.push.requested';
export const Q_OICP_GATEWAY_EVSE_STATUS_PUSH_DLQ = 'q.oicp-gateway.evse-status.push.requested.dlq';

// ---- oicp.evse.recovery.requested (oicp-gateway → backend) ------------
// Richiesta di full-load recovery post-603 "unknown EVSE". Il subject della
// routing key è l'operatorId normalizzato (es. ITYFL); il bind è comunque
// wildcard. Scheduling/coalescing NON sono qui: restano nella coda Redis
// interna del backend (vedi oicp-cpo-recovery.interface.ts).
export const oicpEvseRecoveryRequestedRoutingKey = (operatorId: string) =>
  `${operatorId}.oicp.evse.recovery.requested`;
export const OICP_EVSE_RECOVERY_REQUESTED_PATTERN = '*.oicp.evse.recovery.requested';

export const Q_BACKEND_OICP_EVSE_RECOVERY = 'q.backend.oicp.evse.recovery.requested';
export const Q_BACKEND_OICP_EVSE_RECOVERY_DLQ = 'q.backend.oicp.evse.recovery.requested.dlq';

// ---- pre-authorization (hold) ----------------------------------------
// backend → engine: richiesta hold all'avvio sessione (subject = sessionId)
export const preauthRequestedRoutingKey = (sessionId: string) => `${sessionId}.preauth.requested`;
export const PREAUTH_REQUESTED_PATTERN = '*.preauth.requested';

// engine → backend: esito hold (gate avvio sessione)
export const preauthAuthorizedRoutingKey = (sessionId: string) => `${sessionId}.preauth.authorized`;
export const PREAUTH_AUTHORIZED_PATTERN = '*.preauth.authorized';
export const preauthFailedRoutingKey = (sessionId: string) => `${sessionId}.preauth.failed`;
export const PREAUTH_FAILED_PATTERN = '*.preauth.failed';

// engine consuma le richieste di hold
export const Q_PAYMENTS_PREAUTH_REQUESTED = 'q.payments.preauth.requested';
export const Q_PAYMENTS_PREAUTH_REQUESTED_DLQ = 'q.payments.preauth.requested.dlq';

// backend consuma gli esiti
export const Q_BACKEND_PREAUTH_AUTHORIZED = 'q.backend.preauth.authorized';
export const Q_BACKEND_PREAUTH_AUTHORIZED_DLQ = 'q.backend.preauth.authorized.dlq';
export const Q_BACKEND_PREAUTH_FAILED = 'q.backend.preauth.failed';
export const Q_BACKEND_PREAUTH_FAILED_DLQ = 'q.backend.preauth.failed.dlq';

// ---- preauth.release.requested (backend → engine, comando fire-and-forget) ----
// Rilascio hold: auto su gate-timeout + azione operatore. L'engine voida + markReleased.
export const preauthReleaseRequestedRoutingKey = (sessionId: string) => `${sessionId}.preauth.release.requested`;
export const PREAUTH_RELEASE_REQUESTED_PATTERN = '*.preauth.release.requested';
export const Q_PAYMENTS_PREAUTH_RELEASE = 'q.payments.preauth.release.requested';
export const Q_PAYMENTS_PREAUTH_RELEASE_DLQ = 'q.payments.preauth.release.requested.dlq';

// ---- preauth.capture.requested (backend → engine, comando fire-and-forget) ----
// Addebito manuale (operatore backoffice) di un hold ACTIVE per un importo scelto,
// da 0 (= "conferma addebito a 0", equivalente a un rilascio quando il void PSP non
// è disponibile) fino al cap autorizzato. L'engine incassa (callSettleS2S) + markCaptured.
export const preauthCaptureRequestedRoutingKey = (sessionId: string) => `${sessionId}.preauth.capture.requested`;
export const PREAUTH_CAPTURE_REQUESTED_PATTERN = '*.preauth.capture.requested';
export const Q_PAYMENTS_PREAUTH_CAPTURE = 'q.payments.preauth.capture.requested';
export const Q_PAYMENTS_PREAUTH_CAPTURE_DLQ = 'q.payments.preauth.capture.requested.dlq';

// ---- payment.cancel.requested (backend → engine, comando fire-and-forget) ----
// Annulla un'autorizzazione che NON ha una sessione: oggi i 0,01 € della verifica
// carta, che vanno rilasciati appena il token è salvato. Gli altri comandi sono
// keyed su sessionId e qui non basterebbero — la chiave è il paymentId del PSP.
// L'utente non aspetta questo esito: fire-and-forget, l'auto-cancellazione del
// profilo resta il backstop se fallisce.
export const paymentCancelRequestedRoutingKey = (paymentId: string) => `${paymentId}.payment.cancel.requested`;
export const PAYMENT_CANCEL_REQUESTED_PATTERN = '*.payment.cancel.requested';
export const Q_PAYMENTS_PAYMENT_CANCEL = 'q.payments.payment.cancel.requested';
export const Q_PAYMENTS_PAYMENT_CANCEL_DLQ = 'q.payments.payment.cancel.requested.dlq';

// ---- hosted-hold.requested / .created (backend ⇄ engine, request/reply) ----
// Apertura di un hold che l'utente paga sulla pagina hosted del PSP: l'engine
// crea l'autorizzazione (è lui a operare sul denaro) e risponde con il link da
// aprire. È l'UNICO comando su cui l'utente sta aspettando davanti allo schermo:
// una sola andata/ritorno, nessuna lettura extra lato engine, latenza loggata.
// La risposta viaggia su una routing key dedicata al correlationId.
export const hostedHoldRequestedRoutingKey = (correlationId: string) => `${correlationId}.hosted-hold.requested`;
export const HOSTED_HOLD_REQUESTED_PATTERN = '*.hosted-hold.requested';
export const Q_PAYMENTS_HOSTED_HOLD = 'q.payments.hosted-hold.requested';
export const Q_PAYMENTS_HOSTED_HOLD_DLQ = 'q.payments.hosted-hold.requested.dlq';

export const hostedHoldCreatedRoutingKey = (correlationId: string) => `${correlationId}.hosted-hold.created`;
export const HOSTED_HOLD_CREATED_PATTERN = '*.hosted-hold.created';
export const Q_BACKEND_HOSTED_HOLD_CREATED = 'q.backend.hosted-hold.created';
export const Q_BACKEND_HOSTED_HOLD_CREATED_DLQ = 'q.backend.hosted-hold.created.dlq';

// ---- payment-link.requested / .created (backend ⇄ engine, request/reply) ----
// Link di pagamento per un INSOLUTO (bank_transaction non incassata): l'operatore
// lo genera dal backoffice e lo manda al cliente. Come hosted-hold è l'engine a
// creare l'autorizzazione sul PSP — il backend non apre mai un'autorizzazione —
// ma qui aspetta un OPERATORE, non un cliente davanti alla colonnina: il vincolo
// di latenza è più lasco, resta però request/reply perché il link va restituito
// alla schermata che l'ha chiesto.
export const paymentLinkRequestedRoutingKey = (correlationId: string) => `${correlationId}.payment-link.requested`;
export const PAYMENT_LINK_REQUESTED_PATTERN = '*.payment-link.requested';
export const Q_PAYMENTS_PAYMENT_LINK = 'q.payments.payment-link.requested';
export const Q_PAYMENTS_PAYMENT_LINK_DLQ = 'q.payments.payment-link.requested.dlq';

export const paymentLinkCreatedRoutingKey = (correlationId: string) => `${correlationId}.payment-link.created`;
export const PAYMENT_LINK_CREATED_PATTERN = '*.payment-link.created';
export const Q_BACKEND_PAYMENT_LINK_CREATED = 'q.backend.payment-link.created';
export const Q_BACKEND_PAYMENT_LINK_CREATED_DLQ = 'q.backend.payment-link.created.dlq';

// ---- payment-link.capture.requested (backend → engine, comando fire-and-forget) ----
// Il cliente ha pagato il link: con la Separazione M.O.T.O. quel pagamento è
// AUTORIZZATO (`AUT`), NON incassato. Per incassare davvero serve una capture, che
// è dell'engine — e con lei la chiusura della riga di ledger. Il backend riceve la
// notify S2S del PSP e pubblica; l'engine verifica lo stato col PSP e incassa.
// Chiave = paymentId: la notify non conosce sessionId né cdrId.
// La routing key ha 4 word e NON collide con `*.payment-link.requested` (3 word).
export const paymentLinkCaptureRequestedRoutingKey = (paymentId: string) => `${paymentId}.payment-link.capture.requested`;
export const PAYMENT_LINK_CAPTURE_REQUESTED_PATTERN = '*.payment-link.capture.requested';
export const Q_PAYMENTS_PAYMENT_LINK_CAPTURE = 'q.payments.payment-link.capture.requested';
export const Q_PAYMENTS_PAYMENT_LINK_CAPTURE_DLQ = 'q.payments.payment-link.capture.requested.dlq';

// ---- refund.requested (backend → engine, comando fire-and-forget) ----
// Rimborso di un pagamento già incassato, triggerato da un operatore dal backoffice.
export const refundRequestedRoutingKey = (cdrId: string) => `${cdrId}.refund.requested`;
export const REFUND_REQUESTED_PATTERN = '*.refund.requested';
export const Q_PAYMENTS_REFUND = 'q.payments.refund.requested';
export const Q_PAYMENTS_REFUND_DLQ = 'q.payments.refund.requested.dlq';

// notification-service ascolta il fallimento hold (fatto di dominio sull'exchange
// economic.events) e decide DA SÉ se/come notificare — l'engine non sa nulla di notifiche.
export const Q_NOTIF_PREAUTH_FAILED = 'q.notification-service.preauth.failed';
export const Q_NOTIF_PREAUTH_FAILED_DLQ = 'q.notification-service.preauth.failed.dlq';

// =====================================================================
// Notification-service — exchange dedicato `notification.events`.
// `economic.events` resta scoped al dominio economico: pattern di bind e
// retro-routing per soggetto non vanno inquinati con i volumi notifiche.
// Stesse convenzioni: topic durable, routing key `{subjectId}.{evento}`,
// queue `q.<servizio>.<evento>` + DLQ `.dlq`.
// =====================================================================

export const NOTIFICATION_EXCHANGE = 'notification.events';

// ---- notification.requested (backend → notification-service) ---------
export const notificationRequestedRoutingKey = (messageId: string) =>
  `${messageId}.notification.requested`;
export const NOTIFICATION_REQUESTED_PATTERN = '*.notification.requested';

export const Q_NOTIF_NOTIFICATION_REQUESTED = 'q.notification-service.notification.requested';
export const Q_NOTIF_NOTIFICATION_REQUESTED_DLQ = 'q.notification-service.notification.requested.dlq';

// ---- email.requested (backend → notification-service) ----------------
export const emailRequestedRoutingKey = (messageId: string) =>
  `${messageId}.email.requested`;
export const EMAIL_REQUESTED_PATTERN = '*.email.requested';

export const Q_NOTIF_EMAIL_REQUESTED = 'q.notification-service.email.requested';
export const Q_NOTIF_EMAIL_REQUESTED_DLQ = 'q.notification-service.email.requested.dlq';

// ---- device.token-invalidated (notification-service → backend) -------
// Il token FCM è troppo lungo/opaco per la routing key: si usa un prefisso
// (solo per retro-routing/debug, il bind è comunque wildcard).
export const deviceTokenInvalidatedRoutingKey = (fcmToken: string) =>
  `${fcmToken.slice(0, 24)}.device.token-invalidated`;
export const DEVICE_TOKEN_INVALIDATED_PATTERN = '*.device.token-invalidated';

export const Q_BACKEND_DEVICE_TOKEN_INVALIDATED = 'q.backend.device.token-invalidated';
export const Q_BACKEND_DEVICE_TOKEN_INVALIDATED_DLQ = 'q.backend.device.token-invalidated.dlq';
